<template>
  <div
    v-if="cookieInfo"
    class="container mb-5 terms-content"
    v-html="getDescriptionByLang(cookieInfo)"
  ></div>
</template>

<style scoped>
.terms-content {
  line-height: 1.6;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
}

.terms-content >>> p,
.terms-content >>> div,
.terms-content >>> span,
.terms-content >>> li {
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  max-width: 100%;
}

.terms-content >>> a {
  word-break: break-all;
  overflow-wrap: anywhere;
}

.terms-content >>> img,
.terms-content >>> table {
  max-width: 100%;
  height: auto;
}

.terms-content >>> .ql-align-justify {
  text-align: justify;
}
.terms-content >>> .ql-align-center {
  text-align: center;
}
.terms-content >>> .ql-align-right {
  text-align: right;
}
</style>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      cookieInfo: null,
      currentLang: localStorage.getItem("igaplus-client-language") || 'az' // default, you can set dynamically or from i18n
    };
  },
  methods: {
    getDescriptionByLang(item) {
      const field = `description_${this.currentLang}`;
      return item[field] || '';
    }
  },
  async mounted() {
    try {
      const response = await axios.get('/termsOfService'); // Adjust API URL if needed
      const data = response.data;
      if (data.length > 0) {
        this.cookieInfo = data[0];
      }
    } catch (error) {
      console.error('Failed to fetch cookie info:', error);
    }
  }
};
</script>
